export default {
    SET_LEVELS: (state, { levels }) => (state.levels = levels),
}
